import { render, staticRenderFns } from "./PricePerItems.vue?vue&type=template&id=61872610"
import script from "./PricePerItems.vue?vue&type=script&lang=ts"
export * from "./PricePerItems.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports